import _extends from "@babel/runtime/helpers/extends";
import _objectWithoutProperties from "@babel/runtime/helpers/objectWithoutProperties";
var _excluded = ["children", "classes", "overrides", "className", "option", "onChange", "value", "isReadOnly", "color", "error"];
import React, { Fragment, useCallback, useMemo } from 'react';
import PropTypes from 'prop-types';
import { createUseStyles, useTheme } from '../../../utils/styles';
import Popover from '../../utils/Popover';
import { getOverrides, useClasses } from '../../../utils/overrides';
import Checkbox from '../../general/Checkbox';
import Icon from '../../general/Icon';
import Text from '../../typography/Text';
import styles from './styles';
var useStyles = createUseStyles(styles, 'CheckboxControl');
function CheckboxControl(_ref) {
  var children = _ref.children,
    classesProp = _ref.classes,
    overridesProp = _ref.overrides,
    classNameProp = _ref.className,
    option = _ref.option,
    onChange = _ref.onChange,
    value = _ref.value,
    isReadOnly = _ref.isReadOnly,
    color = _ref.color,
    error = _ref.error,
    props = _objectWithoutProperties(_ref, _excluded);
  var classes = useClasses(useStyles, classesProp);
  var theme = useTheme();
  // Overrides
  var override = getOverrides(overridesProp, CheckboxControl.overrides);
  var onChangeCheckbox = useCallback(function (e) {
    e.stopPropagation && e.stopPropagation();
    onChange && onChange(option.value, e);
  }, [onChange, option]);
  var infoDetails = useMemo(function () {
    if (!option.hint || !option.hint.title && !option.hint.body) return;
    return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement(Text, {
      type: "button",
      className: classes.popoverTitle
    }, option.hint.title), /*#__PURE__*/React.createElement(Text, null, option.hint.body));
  }, [classes.popoverTitle, option.hint]);
  return /*#__PURE__*/React.createElement(Fragment, null, /*#__PURE__*/React.createElement("div", {
    className: classes.checkboxWrapper,
    key: option.value
  }, /*#__PURE__*/React.createElement("div", _extends({
    className: classes.checkboxControl,
    onClick: isReadOnly ? undefined : function () {
      return onChangeCheckbox(option.value);
    }
  }, override.checkboxControl), /*#__PURE__*/React.createElement(Checkbox, {
    checked: value,
    isDisabled: isReadOnly,
    color: color
  }), /*#__PURE__*/React.createElement("span", _extends({
    className: classes.checkboxLabel
  }, override.checkboxLabel), option.label)), option.hint && /*#__PURE__*/React.createElement("div", {
    className: classes.iconContainer
  }, /*#__PURE__*/React.createElement(Popover, _extends({
    className: classes.Popover,
    placement: "left",
    content: infoDetails
  }, override.Popover), /*#__PURE__*/React.createElement(Icon, {
    className: classes.info,
    color: theme.colors.neutral600,
    name: "info",
    size: "small"
  })))), error && /*#__PURE__*/React.createElement("div", _extends({
    className: classes.errorPerCheck
  }, override.errorPerCheck), error));
}
CheckboxControl.overrides = ['checkboxLabel', 'checkboxControl'];
CheckboxControl.defaultProps = {
  onChange: function onChange() {},
  value: false,
  option: {},
  isReadOnly: false
};
process.env.NODE_ENV !== "production" ? CheckboxControl.propTypes = {
  className: PropTypes.string,
  overrides: PropTypes.object,
  onChange: PropTypes.func,
  option: PropTypes.shape({
    label: PropTypes.string,
    value: PropTypes.string,
    hint: PropTypes.shape({
      title: PropTypes.string,
      body: PropTypes.string
    })
  }),
  value: PropTypes.bool,
  isReadOnly: PropTypes.bool
} : void 0;
export default /*#__PURE__*/React.memo(CheckboxControl);